import {
    baseUrl
} from '@/config/env';
import request from '@/router/axios';
import {
    parseParam
} from '@/util/util';

export const findceilingList = (params) => {
    params = parseParam(params)
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/stuff/ceiling_list?` + params,
        method: 'GET'
    })
}
export const setCeiling = (params) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/stuff/set_ceiling`,
        method: 'POST',
        data: params
    })
}
export const editCeiling = (params) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/stuff/edit_ceiling`,
        method: 'PUT',
        data: params
    })
}
export const delCeiling = (id) => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/stuff/delete_ceiling/${id}`,
        method: 'DELETE'
    })
}
export const getCeiling = () => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/stuff/get_ceiling`,
        method: 'GET'
    })
}
export const getIntegralValue = () => {
    return request({
        url: `${baseUrl}/joins-sales-cloud/v1/stuff/get_integral_value`,
        method: 'GET'
    })
}